import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
// call ckeditor css in all project for image or color
import './assets/css/ckeditor.css'
// @ts-ignore
import Vuelidate from 'vuelidate'
// @ts-ignore
import selectFind from "./components/base/selectFind.vue"
import selectFindTags from "./components/base/selectFindTags.vue"
import selectAsync from "./components/base/selectAsync.vue"
import selectAsyncMultple from "./components/base/selectAsyncMultiple.vue"
import selectFindMultiple from "./components/base/selectFindMultiple.vue"
import requiredComponent from "./components/base/required.vue"
import treeFolder from "./components/tree/treeFolder.vue"
import treeFolderContents from "./components/tree/treeFolderContents.vue"
// @ts-ignore
import Transitions from 'vue2-transitions'
Vue.use(Transitions)
import mdiVue from 'mdi-vue'
import * as mdijs from '@mdi/js'

Vue.use(mdiVue, {
  icons: mdijs
})
Vue.component('tree-folder', treeFolder)
Vue.component('tree-folder-contents', treeFolderContents)
Vue.use(require('vue-jalali-moment'));

// @ts-ignore
import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside)

// @ts-ignore
import CKEditor from '@ckeditor/ckeditor5-vue';
// @ts-ignore
import httpService from './plugins/httpService'
import appConfig from './plugins/appConfig'
import appLangs from './plugins/appLangs'
import notification from './plugins/notification'
import errorHandling from './plugins/errorHandling'
import { RouterModule } from '@/router'
import { StoreModule } from '@/store'
import { ServiceModule } from '@/service'
import { CoreModule } from '@/core'
import customConfig from "@/plugins/customConfig"

// generate active modules of env variable
let modules = process.env.VUE_APP_ACTIVE_MODULES
modules = modules.replace('[', '').replace(']', '').replaceAll("'", '')
modules = modules.split(',')

function bootstrap() {
  Vue.use(CKEditor);
  Vue.use(Vuelidate)
  Vue.use(BootstrapVue)
  Vue.use(httpService)
  Vue.use(appConfig, { modules })
  Vue.use(appLangs, { modules })
  Vue.use(notification)
  Vue.use(errorHandling)
  Vue.use(customConfig)
  Vue.component('selectFind', selectFind)
  Vue.component('selectFindTags', selectFindTags)
  Vue.component('selectAsync', selectAsync)
  Vue.component('selectAsyncMultple', selectAsyncMultple)
  Vue.component('selectFindMultiple', selectFindMultiple)
  Vue.component('requiredComponent', requiredComponent)
  Vue.config.productionTip = false
  Vue.prototype.$fa_lang = process.env.VUE_APP_PROJECT_NAME

  const routerModule = new RouterModule()
  routerModule.install(Vue)

  const storeModule = new StoreModule()
  storeModule.install(Vue)

  const serviceModule = new ServiceModule(modules)
  serviceModule.install(Vue)

  const coreModule = new CoreModule(routerModule.router!, storeModule.store!, serviceModule.service!)
  coreModule.install(Vue)

  // install active modules
  modules.map((module: string) => {
    try {
      const Module = require(`@/modules/${module}`)
      const name = `${module.charAt(0).toUpperCase()}${module.slice(1)}Module`
      let instance = new Module[name](routerModule.router!, storeModule.store!, serviceModule.service!)
      instance.install(Vue)
    } catch (error) {
      //
    }
  })
  return [routerModule.router!, storeModule.store!]
}

const [Router, Store] = bootstrap();
export const router = Router;
export const store = Store;

// @ts-ignore
import VueMatomo from 'vue-matomo';
// tracking by matomo 
if (process.env.VUE_APP_MATOMO_ACTIVE === 'true') {
  Vue.use(VueMatomo, {
    host: process.env.VUE_APP_MATOMO_URL,
    siteId: process.env.VUE_APP_MATOMO_SETSITEID,
    trackerUrl: `${process.env.VUE_APP_MATOMO_URL}/matomo.php`,
    trackerFileName: 'matomo',
    router: Router,
    enableLinkTracking: true,
    requireConsent: false,
    trackInitialView: true,
    disableCookies: false,
    debug: false,
  });
}